import Home from './Home'
import Games from './Games'
import Rates from './Rates'
import Privacy from './Privacy'
import Terms from './Terms'
import Advertisers from './Advertisers'
import About from './About'
import Contact from './Contact'
import Info from './Info'
import Login from './Login'
import Remind from './Remind'
import Register from './Register'
import Partners from './Partnets'

import Community from './Community'
import User from './User'
import Settings from './Settings'
import News from './News'

import Transactions from './Transactions'
import StatisticsMain from './Statistics/index'
import SupportMain from './Support/index'
import SupportCreate from './Support/SupportCreate'
import SupportView from './Support/SupportView'

import partials from './partials'

export default {
  Home,
  Games,
  Rates,
  Privacy,
  Terms,
  Advertisers,
  About,
  Contact,
  Info,
  Login,
  Remind,
  Register,

  News,
  Transactions,
  Statistics: {
    Main: StatisticsMain
  },
  Support: {
    Main: SupportMain,
    Create: SupportCreate,
    View: SupportView
  },
  Community,
  User,
  Settings,
  Partners,
  partials
}



// WEBPACK FOOTER //
// ./src/components/index.js